<template>
  <div>
    <button
      class="w-100 py-2 mb-2 btn btn-outline-secondary rounded-3"
      @click="redirectToGitHubOAuth"
      type="button"
    >
      <span><i class="bi bi-github"></i></span><span> GitHub</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "OAuthButtons",
  methods: {
    redirectToGitHubOAuth() {
      const clientID = "7c3000653e682bd729cc"; // 使用你的 GitHub 客户端ID
      const redirectURI = encodeURIComponent(
        "http://localhost:8080/auth/callback"
      ); // 重定向URI
      const scope = "read:user"; // 请求的权限范围
      window.location.href = `https://github.com/login/oauth/authorize?client_id=${clientID}&redirect_uri=${redirectURI}&scope=${scope}`;
    },
  },
};
</script>

<style scoped>
/* 添加特定的样式 */
</style>
